import { useForm } from "react-hook-form";
import { z } from "zod";
import { MiDetailFields, MiModal } from "@miplatform/components";
import { zodResolver } from "@hookform/resolvers/zod";
import { useAddAreaTemplateModalViewModel } from "./useAddAreaTemplateModalViewModel";

const schema = z.object({
  name: z.string().min(1, "Template Name is required"),
});

export function AddAreaTemplateModal({
  stateManager,
  open,
  closeModal,
  planDetails,
  getAreaTemplates,
}) {
  const {
    formState: { isValid },
    control,
    getValues,
    reset,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      name: "",
    },
    resolver: zodResolver(schema),
  });

  const { handleCreateAreaTemplate, isLoading } =
    useAddAreaTemplateModalViewModel({
      stateManager,
      closeModal,
      reset,
      getAreaTemplates,
    });

  const areaTemplateName = [
    {
      name: "name",
      label: "Template Name",
      required: true,
      formControl: control,
      style: { width: "100%" },
    },
  ];

  return (
    <MiModal
      open={open}
      actions={[
        {
          name: "Cancel",
          onClick: () => {
            closeModal();
            reset();
          },
          disabled: isLoading,
        },
        {
          name: "Submit",
          disabled: !isValid || isLoading,
          onClick: () => {
            const areaTemplateName = getValues("name");
            handleCreateAreaTemplate({
              ...planDetails,
              currentStep: 0,
              name: areaTemplateName,
            });
          },
          variant: "contained",
        },
      ]}
      title="Area Template"
      description="Enter name to save current areas as an Area Template."
      closeModal={() => {
        closeModal();
        reset();
      }}
    >
      <MiDetailFields detailFields={areaTemplateName} />
    </MiModal>
  );
}
